import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";


export const useValveConditions = (frameId: string) => {
    return useQuery(["valve-conditions", frameId], () => new Client().compressor_GetCurrentValveDataForCompressor(frameId));
}